import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=0fca01ee&scoped=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=0fca01ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca01ee",
  null
  
)

export default component.exports